import { render, staticRenderFns } from "./PartnersItemView.vue?vue&type=template&id=286849ba&scoped=true&"
import script from "./PartnersItemView.vue?vue&type=script&lang=js&"
export * from "./PartnersItemView.vue?vue&type=script&lang=js&"
import style0 from "./PartnersItemView.vue?vue&type=style&index=0&id=286849ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286849ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer})
